export const filter = (() => {
    const videoplaybtns = document.querySelectorAll(".video-play");
    const videoplayer = document.getElementById("videoplayer");
    Array.from(videoplaybtns).forEach((btn) => addEL(btn));

    function addEL(btn) {
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            Array.from(videoplaybtns).forEach((btn) => { btn.classList.remove("video-play--active"); btn.setAttribute("aria-label", "Välj klipp") });
            btn.classList.add("video-play--active");
            btn.setAttribute("aria-label", "Aktivt klipp")
            videoplayer.setAttribute("src", btn.getAttribute("data-link"));
        });
    }

})();